<template>
    <app-popover v-if="$slots.default" @open="setOpen(true)" @close="setOpen(false)" ref="popover" :wrapper-element="wrapperElement"
        :style="{display: wrapperElement === 'div' ? 'block' : 'inline', float}"
        :class="['action-menu', {'action-menu-button-small': small, 'action-menu-button-smaller': smaller, 'action-menu-button-tiny': tiny, 'action-menu-open': isOpen}]" :position="position" v-bind="$attrs"
        container-class="round bordered" :auto-focus-first-element="true" class="no-print">
        <template #default="{toggle, isOpen}">
            <slot name="button" :toggle="toggle" :is-open="isOpen" :tooltip-text="{text: title}">
                <button type="button" class="mdl-button mdl-button--icon" v-tooltip="{text: title}" @click.prevent.stop="toggle" :aria-label="title">
                    <i class="material-icons pointer" :class="iconClass" aria-hidden="true" role="img">more_vert</i>
                </button>
            </slot>
        </template>
        <template #container>
            <ul class="portuna-menu" @click.left="click">
                <slot/>
            </ul>
        </template>
    </app-popover>
</template>

<script setup lang="ts">
    import AppPopover from './AppPopover.vue';
    import {ref, computed} from 'vue';

    const props   = withDefaults(
        defineProps<{
            title?: string;
            right?: boolean;
            noFloat?: boolean;
            small?: boolean;
            smaller?: boolean;
            tiny?: boolean;
            wrapperElement?: string;
            position?: AlignmentPosition;
            iconClass?: VueCssClass;
        }>(),
        {
            title: 'Bearbeitungsoptionen',
            right: false,
            noFloat: false,
            small: false,
            smaller: false,
            tiny: false,
            wrapperElement: 'span',
            position: 'bottom-right',
            iconClass: '',
        },
    );
    const popover = ref<AppPopover>();
    const isOpen  = ref<Boolean>(false);
    const float   = computed(() =>
    {
        if (props.noFloat)
        {
            return null;
        }
        return props.right ? 'right' : 'left';
    });
    const click   = () =>
    {
        popover.value && popover.value.close();
    };

    const setOpen = (value: boolean) =>
    {
        isOpen.value = value;
    };
</script>